import React from 'react'

const Footer = () => {
    return (
      <footer>
        <p>
          © 2020 by Filip Krawczyk
        </p>
      </footer>
    );
}

export default Footer